import dayjs, { Dayjs } from "dayjs"
import dayjs_plugin_utc from "dayjs/plugin/utc"

dayjs.extend(dayjs_plugin_utc)

export type DateRange = [string, string]

export const getDateRangeFromOption = (value: string): DateRange => {
  const now = dayjs()

  if (value === "custom") {
    const endDate = now.subtract(1, "day")
    const startDate = endDate.subtract(6, "day")
    return [startDate.format("YYYY-MM-DD"), endDate.format("YYYY-MM-DD")]
  }

  if (value === "all") {
    return ["", ""]
  }

  if (value === "this-year") {
    return [now.startOf("year").format("YYYY-MM-DD"), now.format("YYYY-MM-DD")]
  }

  if (value === "last-year") {
    const lastYear = now.subtract(1, "year")
    return [lastYear.startOf("year").format("YYYY-MM-DD"), lastYear.endOf("year").format("YYYY-MM-DD")]
  }

  if (value === "last-month") {
    const lastMonth = now.subtract(1, "month")
    return [lastMonth.startOf("month").format("YYYY-MM-DD"), lastMonth.endOf("month").format("YYYY-MM-DD")]
  }

  const days = parseInt(value, 10) || 7
  const endDate = now.subtract(1, "day")
  const startDate = endDate.subtract(days - 1, "day")
  return [startDate.format("YYYY-MM-DD"), endDate.format("YYYY-MM-DD")]
}

export const getLastNDaysExcludingToday = (daysCount: number): { startDate: Dayjs; endDate: Dayjs } => {
  const startDate = dayjs().utc().subtract(daysCount, "day").startOf("day")
  const endDate = dayjs().utc().subtract(1, "day").startOf("day")

  return { startDate, endDate }
}

export const getTimeZoneFullText = (timeZone: string) => {
  if (!timeZone) return null

  if (timeZone === "UTC") return "UTC"

  return `${timeZone.replace("_", " ")} UTC ${dayjs()
    .tz(timeZone || "UTC")
    .format("Z")}`
}

export const parseDateField = (date?: string | null, format: string = "L") => (date ? dayjs(date).format(format) : date)

export const stringifyDateRange = (dateRange: [Dayjs | null | string, Dayjs | null | string], showLongText = false) => {
  const start =
    typeof dateRange[0] === "string" ? (dateRange[0] ? dayjs(dateRange[0]).format("L") : "") : dateRange[0]?.format("L")
  const end =
    typeof dateRange[1] === "string" ? (dateRange[1] ? dayjs(dateRange[1]).format("L") : "") : dateRange[1]?.format("L")

  if (start && end && start === end) {
    return start
  }

  if (showLongText && start && end) {
    return `from ${start} to ${end}`
  }

  if (start && end) {
    return `${start} - ${end}`
  }

  if (start) {
    return `from ${start}`
  }

  if (end) {
    return `until ${end}`
  }

  return ""
}
